<template>
  <div class="login">
    <div class="logo">
      <img src="https://itop.zmn.cn/img/logo.png" alt="">
      <p>正规家庭维修，就找啄木鸟</p>
    </div>
    <div class="login-box">
      <div class="login-item">
        <div class="login-info">
          <div class="login-title">钉钉扫码 快速登录</div>
          <div class="login-corpName">重庆啄木鸟网络科技有限公司</div>
        </div>
        <!-- STEP1：在HTML中添加包裹容器元素 -->
        <div class="code-box">
          <div id="self_defined_element" class="self-defined-classname"></div>
        </div>
      </div>
    </div>
    <p class="login-copyright">
      重庆啄木鸟网络科技有限公司 All Right Reserved | 渝ICP备15001851号-1
    </p>
    <!--  弹窗  -->
    <div class="organ-dialog">
      <div class="organ-dialog-box">
        <div class="organ-back-box"><em class="organ-back-icon"></em>返回</div>
        <div class="organ-content-box">
          <h2 class="organ-title">选择你组织快速登录</h2>
          <div class="organ-list"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

// 钉钉登录配置
const DINGTALK_CONFIG = {
  client_id: "dinggepvt8jfxxzreiw9",
  corpId: "ding604c3166bcf39424", 
  proof: "31D9070BB66A87EDBCEA130716996081",
  redirect_uri: "https://snsys.xiujiadian.com/api/dingding/challenge"
}

// 动态加载外部脚本
const loadScript = (src: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.onload = () => resolve()
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`))
    document.head.appendChild(script)
  })
}

// 动态加载样式
const loadStyle = (href: string): void => {
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = href
  document.head.appendChild(link)
}

onMounted(async () => {
  try {
    // 设置body属性和样式
    document.body.setAttribute('onselectstart', 'return false')
    document.body.id = 'off'

    // 加载外部样式
    loadStyle('https://itop.zmn.cn/css/all.css')
    loadStyle('https://itop.zmn.cn/login/css/popup.css')

    // 加载外部脚本
    await loadScript('https://itop.zmn.cn/js/jquery.min.js')
    await loadScript('https://itop.zmn.cn/js/all.js')
    await loadScript('https://itop.zmn.cn/login/js/js.cookie.min.js')
    await loadScript('https://g.alicdn.com/dingding/h5-dingtalk-login/0.21.0/ddlogin.js')
    
    // 设置钉钉配置到全局
    ;(window as any).DINGTALK_CONFIG = DINGTALK_CONFIG
    
    // 设置配置变量
    ;(window as any).client_id = DINGTALK_CONFIG.client_id
    ;(window as any).corpId = DINGTALK_CONFIG.corpId
    ;(window as any).proof = DINGTALK_CONFIG.proof
    ;(window as any).redirect_uri = DINGTALK_CONFIG.redirect_uri

    await loadScript('https://itop.zmn.cn/login/js/dialog.js')
    await loadScript('https://itop.zmn.cn/login/js/dingtalk.js')

  } catch (error) {
    console.error('Failed to load external resources:', error)
  }
})
</script>

<style scoped>
.code-box {
  margin-top: 70px; /* 可根据需要调整数值 */
}

.login-copyright {
  position: absolute;
  z-index: 1;
  bottom: 18px;
  left: 50%;
  margin: 0;
  color: #91a4b2;
  font-size: 12px;
  white-space: nowrap;
  transform: translateX(-50%);
}
</style>
